import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [
    'toolbar',
    'selectAll',
    'checkbox',
    'selectedCount',
    'actionSelect',
    'contentInput',
    'actionInput',
    'submitButton',
    'submitText',
    'actionForm',
    'requiredField',
  ]

  connect() {
    this.refreshActionFormSubmit()
  }

  updateSelection() {
    this.refreshState()
  }

  toggleAll() {
    const shouldCheck = this.checkboxTargets.some((cb) => !cb.checked)
    this.checkboxTargets.forEach((cb) => {
      cb.checked = shouldCheck
    })
    this.refreshState()
  }

  updateButtonLabel() {
    this.refreshSubmitButton()
  }

  clearSelection() {
    this.checkboxTargets.forEach((cb) => {
      cb.checked = false
    })
    if (this.hasSelectAllTarget) {
      this.selectAllTarget.checked = false
      this.selectAllTarget.indeterminate = false
    }
    this.refreshState()
  }

  refreshState() {
    const count = this.selectedIds.length
    const total = this.checkboxTargets.length

    this.toolbarTarget.classList.toggle('hidden', count === 0)

    if (this.hasSelectedCountTarget) {
      this.selectedCountTarget.textContent = `${count} ${count === 1 ? 'program' : 'programs'} selected`
    }

    if (this.hasSelectAllTarget) {
      if (count === 0) {
        this.selectAllTarget.indeterminate = false
        this.selectAllTarget.checked = false
      } else if (count === total) {
        this.selectAllTarget.indeterminate = false
        this.selectAllTarget.checked = true
      } else {
        this.selectAllTarget.indeterminate = true
      }
    }

    if (this.hasContentInputTarget) {
      this.contentInputTarget.value = this.selectedIds.join(',')
    }

    this.refreshSubmitButton()
  }

  refreshSubmitButton() {
    const count = this.selectedIds.length
    const action = this.hasActionSelectTarget
      ? this.actionSelectTarget.value
      : ''

    if (this.hasActionInputTarget) this.actionInputTarget.value = action

    const ready = count > 0 && action !== ''
    if (this.hasSubmitButtonTarget) this.submitButtonTarget.disabled = !ready

    if (this.hasSubmitTextTarget) {
      this.submitTextTarget.textContent = ready
        ? this.#buttonLabel(action, count)
        : action
          ? this.#buttonLabel(action, count)
          : 'Choose Option'
    }
  }

  refreshActionFormSubmit() {
    if (!this.hasActionFormTarget || !this.hasSubmitButtonTarget) return

    const requiredFields = this.hasRequiredFieldTarget
      ? this.requiredFieldTargets
      : this.actionFormTarget.querySelectorAll('[required]')
    const ready = Array.from(requiredFields).every((field) => {
      if (field.disabled) return true

      if (field.type === 'checkbox' || field.type === 'radio') {
        return field.checked
      }

      return field.value?.toString().trim() !== ''
    })

    this.submitButtonTarget.disabled = !ready
  }

  get selectedIds() {
    return this.checkboxTargets.filter((cb) => cb.checked).map((cb) => cb.value)
  }

  #buttonLabel(action, count) {
    const noun = count === 1 ? 'program' : 'programs'
    switch (action) {
      case 'email':
        return `Email ${count} ${noun}`
      case 'pdf':
        return `Create ${count} Program Offer ${count === 1 ? 'PDF' : 'PDFs'}`
      case 'outreach_eligibility':
        return `Set Outreach Eligibility for ${count} ${noun}`
      default:
        return `Apply to ${count} ${noun}`
    }
  }
}
